import { SYSTEM_ROLE_CODE } from "@/schemas/user";

export const SUPPORTED_SYSTEM_ROLE_CODES = [
  SYSTEM_ROLE_CODE.REGIONAL_DIRECTOR,
  SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE,
  SYSTEM_ROLE_CODE.STORE_COORDINATOR,
  SYSTEM_ROLE_CODE.VICE_STORE_COORDINATOR,
  SYSTEM_ROLE_CODE.SUPERVISOR,
];
